/**
 * Copyright IBM Corp. 2021
 *
 * This source code is licensed under the IBM Public License Version 1.0 found in the
 * LICENSE file in the root directory of this source tree.
 */

import { TriModel } from "./TriModel";
import TriModelApi from "./api/TriModelApi";
export { TriModelApi, TriModel };
